<script setup lang="ts">
// TODO: Accept incident prop and wire up payment integration when available
</script>

<template>
  <q-card>
    <q-card-section>
      <div class="row items-center q-gutter-x-sm">
        <span class="text-subtitle1 text-weight-medium">Get the footage</span>
        <q-chip color="orange" text-color="white" size="sm" label="Coming Soon" dense />
      </div>
    </q-card-section>

    <q-separator inset />

    <q-card-section>
      <p class="text-body2 text-grey-7 q-mb-none">
        Purchase and download high-resolution footage directly from the uploader.
      </p>

      <ul>
        <li>
          Unredacted: Select this to receive the original media file and metadata for use as legal
          evidence.
        </li>
        <li>
          Redacted: Select this for a version where identifying features have been obscured, making
          it suitable for public display.
        </li>
      </ul>
    </q-card-section>

    <q-card-section class="row q-gutter-sm q-pt-none">
      <q-btn
        unelevated
        color="primary"
        icon="mdi-video-box-off"
        label="Purchase Redacted Footage"
        disabled
      >
        <q-tooltip>Coming soon</q-tooltip>
      </q-btn>

      <q-btn
        unelevated
        color="secondary"
        icon="mdi-video-box"
        label="Purchase Unredacted Footage"
        disabled
      >
        <q-tooltip>Coming soon</q-tooltip>
      </q-btn>
    </q-card-section>
  </q-card>
</template>
